// @flow
import { media } from '~/core/utils/style';
import styled from 'styled-components';

export const Main = styled.div`
    margin: 1em;

    ${media.tablet`
        font-size: 14px;
		margin: 1.5em;
	`};
    ${media.desktop`
		margin: 2em;
	`};
`;

export const FrequencyContainer = styled.div`
    border: solid 1px ${p => p.theme.mainBrandColor};
    border-radius: 0.5em;
    overflow: hidden;
    margin-bottom: 0.5em;
`;

export const ScheduleContainer = styled.div`
    margin-bottom: 2em;
    position: relative;
    opacity: ${p => (p.show ? 1 : 0.2)};
    pointer-events: ${p => (p.show ? 'inherit' : 'none')};

    transition: opacity 0.3s ease-out;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/recipe-schedule/style.js